import { AfterContentInit, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup } from '@angular/forms';
import { SotiPopupTrigger } from '@soti/popup';
import { IMonitorInfo } from '../../../remote-control-ng/definitions';

@Component({
  selector: 'xsight-multi-display-popup',
  templateUrl: './multi-display-popup.component.html',
  styleUrls: ['./multi-display-popup.component.scss'],
})
export class MultiDisplayPopupComponent implements OnInit, AfterContentInit {
  @Input() getPopupTrigger: () => SotiPopupTrigger;
  @Input() availableDisplays: IMonitorInfo[];
  @Input() activeDisplay: IMonitorInfo;
  @Output() public itemSelected = new EventEmitter<string>();

  public form: FormGroup;
  private selectDisplayId: number;

  constructor(private fb: FormBuilder) {
    this.selectDisplayId = -1;
  }

  ngOnInit(): void {
    this.form = this.fb.group({
      displayScreen: [null],
    });
  }

  ngAfterContentInit(): void {
    if (this.selectDisplayId < 0) {
      this.selectDisplayId = this.activeDisplay ? this.activeDisplay.id : 0;
    }
  }

  public onSubmit() {
    if (!!this.displayScreen.value) {
      this.selectDisplayId = this.displayScreen.value.id;
      this.itemSelected.emit(this.displayScreen.value);
    }
    this.getPopupTrigger().close();
  }

  public onClose() {
    this.getPopupTrigger().close();
  }
  get displayScreen(): AbstractControl {
    return this.form.get('displayScreen');
  }
}
